<template>
  <Viewer class="exercise-detail" :isOpenBookCats="openBookCats" :linkBack="examInfo ? { name:'exercise', query:{ lop: classId, mon: subjectId, tab: typeId} } : {}">
    <template v-if="examInfo" v-slot:viewer_head_name>{{ examInfo.name }}</template>
    <template v-if="examInfo" v-slot:viewer_head_right>{{ versionApp }}</template>
    <template v-slot:viewr_body>
      <div class="container-hts">
        <div class="exercise-detail__info exercise-exam__info">
          <PreviewBookImg v-if="examInfo && examInfo.fileNameExam" :totalPage="examInfo.totalPageExam" :fileName="examInfo.fileNameExam" :scale="1" />
          <img v-else :src="examInfo.thumbnail ? `${urlImg}/${examInfo.thumbnail}` : img404" :alt="examInfo.name">
        </div>
      </div>
    </template>
    <template v-slot:viewer_toggle_cat_name>Danh sách</template>
    <template v-slot:viewer_footer_right>
      <a
        href="javascript:;"
        class="btn btn-main border-rd-20 letter-spacing-main line-height-1-2 font-size-16 btn-do-ex"
        :disabled="!examInfo || (examInfo && examInfo.numberQuestion && examInfo.numberQuestion === 0)"
        @click="directToQuestion"
      >
        {{ examInfo && examInfo.isWork === typeExamDone ? 'Xem kết quả' : 'Làm bài' }}
      </a>
    </template>
    <template v-slot:viewer_sidebar_cat_head>
      <h2 class="book-viewer__cats__title primary-color-txt font-size-24 font-sanpro-semibold book-viewer__cats__wrap">
        Thông tin
      </h2>
    </template>
    <template v-slot:viewer_sidebar_cat_body>
      <ExamSidebar :dataSource="examInfo" />
    </template>
  </Viewer>
</template>

<script>
  // import VRuntimeTemplate from "v-runtime-template"
  import { APP_CONFIG } from "@/utils/constants"
  import { mapState, mapActions } from "vuex"
  import { STORE_KEY, LOCAL_SAVE_QUESTIONS_WORKED, EXAM_WORKED_DONE } from "./../../_store/constants"
  import { getExamDetail } from './../../_api/'
  import ExamSidebar from './../../_components/exam/ExamSidebar.vue'
  const img404 = require(`@/assets/images/img_404.jpg`)
  import PreviewBookImg from '@/components/content-files/PreviewBookImg.vue';
  import Viewer from '@/layouts/Viewer.vue'
  
  export default {
    name: 'ThematicDetail',
    components: {
      // VRuntimeTemplate,
      ExamSidebar,
      PreviewBookImg,
      Viewer
    },
    data () {
      return {
        authInfo: {},
        examInfo: {},
        openBookCats: true,
        urlImg: APP_CONFIG.urlQuestionImg,
        img404,
        typeExamDone: EXAM_WORKED_DONE
      };
    },
      
    computed: {
      ...mapState('common', ['versionApp']),
      routerParams() {
        return this.$route.params;
      },
      classId() {
        return parseInt(this.$route.params.classId);
      },
      subjectId() {
        return parseInt(this.$route.params.subjectId);
      },
      screenWidth() {
        return window.innerWidth;
      },
      examId() {
        return parseInt(this.$route.params.id);
      },
      typeId() {
        return parseInt(this.$route.params.typeId);
      }
    },
    created() {
      this.getInfoDetail()
    },
    mounted () {
      localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED)
    },
    methods: {
      ...mapActions('common', ['setLoading']),
      ...mapActions('auth', ['setToggleLoginForm']),
      ...mapActions(STORE_KEY, ['acSetParamFilterOtherThematic']),

      getInfoDetail () {
        this.setLoading(true)
        getExamDetail(this.examId).then(res => {
          if (res && res.data && !res.errors) {
            this.examInfo = res.data
          }
        }).finally(() => this.setLoading(false))
      },

      handleToggleBookCats() {
          this.openBookCats = !this.openBookCats;
      },

      directToQuestion () {
        this.$router.push({name: 'exerciseExamQuestion', params: {...this.routerParams}, query: {cauhoi: 1}})
        // this.examInfo.isWork && this.$router.push({name: 'exerciseExamResult', params: { id: this.examInfo.examId, typeId: this.typeId }})
      }
    }
  };
</script>

<style lang="scss" scoped>
    .book-viewer__cats .card-body ul li:not(:last-child) {
        margin-bottom: 15px;
    }

    .cat-head, .cat-child li {
        @extend .display-flex;
        @extend .justify-content-between;

        >i {
            @extend .position-rel;
            top: 5px;
            @extend .font-size-20;
        }
    }

    @media screen and ( max-width: 767px ) {
        .exercise-detail {
            
            &__questions {
                padding: 15px 0;
            }
        }
    }
    .btn-do-ex{
      height: 30px;
      line-height: 28px;
      padding: 0px 20px;
    }
    .exercise-exam__info {
      padding: 0;
    }
</style>